// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/service_account.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateServiceAccountAccessTokenRequest, CreateServiceAccountAccessTokenResponse, CreateServiceAccountRequest, CreateServiceAccountResponse, DeleteServiceAccountRequest, DeleteServiceAccountResponse, GetServiceAccountRequest, GetServiceAccountResponse, ListServiceAccountsRequest, ListServiceAccountsResponse, UpdateServiceAccountRequest, UpdateServiceAccountResponse } from "./service_account_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.ServiceAccountService
 */
export const ServiceAccountService = {
  typeName: "gitpod.v1.ServiceAccountService",
  methods: {
    /**
     * Creates a new service account in an organization.
     *
     * Use this method to:
     * - Create service accounts for automation
     * - Set up CI/CD credentials
     * - Configure programmatic access
     *
     * ### Examples
     *
     * - Create service account:
     *
     *   Creates a service account for automation.
     *
     *   ```yaml
     *   name: "ci-pipeline"
     *   description: "CI/CD Pipeline"
     *   validUntil: "2025-12-31T23:59:59Z"
     *   ```
     *
     * @generated from rpc gitpod.v1.ServiceAccountService.CreateServiceAccount
     */
    createServiceAccount: {
      name: "CreateServiceAccount",
      I: CreateServiceAccountRequest,
      O: CreateServiceAccountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists service accounts in an organization.
     *
     * Use this method to:
     * - View all service accounts
     * - Audit service account usage
     * - Manage service account lifecycle
     *
     * ### Examples
     *
     * - List service accounts:
     *
     *   Shows all service accounts in an organization.
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.ServiceAccountService.ListServiceAccounts
     */
    listServiceAccounts: {
      name: "ListServiceAccounts",
      I: ListServiceAccountsRequest,
      O: ListServiceAccountsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets details about a specific service account.
     *
     * Use this method to:
     * - View service account details
     * - Check service account status
     * - Retrieve service account metadata
     *
     * ### Examples
     *
     * - Get service account:
     *
     *   Retrieves details about a specific service account.
     *
     *   ```yaml
     *   serviceAccountId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.ServiceAccountService.GetServiceAccount
     */
    getServiceAccount: {
      name: "GetServiceAccount",
      I: GetServiceAccountRequest,
      O: GetServiceAccountResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates a service account.
     *
     * Use this method to:
     * - Update service account name or description
     *
     * ### Examples
     *
     * - Update name and description:
     *
     *   Updates the service account name and description.
     *
     *   ```yaml
     *   serviceAccountId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   name: "updated-ci-pipeline"
     *   description: "Updated CI/CD Pipeline"
     *   ```
     *
     * @generated from rpc gitpod.v1.ServiceAccountService.UpdateServiceAccount
     */
    updateServiceAccount: {
      name: "UpdateServiceAccount",
      I: UpdateServiceAccountRequest,
      O: UpdateServiceAccountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes a service account.
     *
     * Use this method to:
     * - Remove unused service accounts
     * - Revoke service account access
     * - Clean up expired accounts
     *
     * ### Examples
     *
     * - Delete service account:
     *
     *   Permanently removes a service account.
     *
     *   ```yaml
     *   serviceAccountId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.ServiceAccountService.DeleteServiceAccount
     */
    deleteServiceAccount: {
      name: "DeleteServiceAccount",
      I: DeleteServiceAccountRequest,
      O: DeleteServiceAccountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a short-lived access token for configuring a service account.
     *
     * The token expires after 30 minutes and can be used as a Bearer token
     * in the Authorization header to perform operations on behalf of the
     * service account, such as configuring OAuth.
     *
     * ### Examples
     *
     * - Create access token:
     *
     *   ```yaml
     *   serviceAccountId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.ServiceAccountService.CreateServiceAccountAccessToken
     */
    createServiceAccountAccessToken: {
      name: "CreateServiceAccountAccessToken",
      I: CreateServiceAccountAccessTokenRequest,
      O: CreateServiceAccountAccessTokenResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

